export default "/images/vendor/flag-icon-css/flags/1x1/je.svg?61157f3ae7c4ea0899866c82b7452e96";